import i18n from './index.js'
export default {//葡萄牙文
  translateText: {
    shoppingcart: "carrinho de compras",
    loginorrefisterText: "entrar/registrar ",
    logoutText: "sair do login",
    personcenterText: "centro pessoal ",
    placeholderText: "por favor, selecione",
    loginText: "entrar",
    registerText: "registrar",
    emailText: "caixa de correio",
    pwdText: "senha",
    forgetpwdText: "esqueceu sua senha?",
    nameText: "nome",
    surnameText: "sobrenome",
    mobileText: "telefone",
    setPwdText: "definir senh",
    countryText: "país",
    company: "empresa",
    birthday: "aniversário",
    yearText: "ano",
    mouthText: "ano",
    dayText: "dia",
    confirmpwdText: "confirmar senha",
    agreeText1: "li e concordo",
    agreeText2: "condições de utilização",
    agreeText3: "e",
    agreeText4: "declaração de privacidade",
    agreeText5: ",e concordo que algumas das minhas informações pessoais serão processadas fora do país de acordo com a declaração de privacidade.",
    emailplaceholder: 'por favor, digite um e-mail',
    subscribetitleText: "subscrever a nossa newslette",
    subscribeText: 'subscrever',
    shareToText: 'compartilhar até ',
    searchText: 'search',
    subtractmoneyText: "menos até 600",
    magnanimitycouponText: "cupons maciços para você pegar",
    drawText: "obter agora",
    discountText: "super muitos descontos",
    purchaseText: "comprar agora",
    composecouponText: "compra combinada",
    manyDiscountsText: "muitas ofertas",
    recommendtitleText: "recomendado para você",
    hotsaleproductyitleText: "produtos de venda quente",
    guessLiketitleText: "acho que você gosta ",
    NoDataText: "não há dados ainda",
    appraiseText: "avaliação",
    certificate: "voucher",
    collectText: "coleção",
    addCartText: "adicionar ao carrinho",
    enterkeywordsText: "digite palavras-chave ",
    useNowText: "para uso imediato ",
    vouchernoText: "número do voucher",
    placeholderyearText: "selecione o ano",
    placeholdermouthText: "selecionar mês",
    placeholderdayText: "selecionar dia",
    // 优惠券页面
    breadcrumbItemText1: 'super',
    breadcrumbItemText2: 'nível',
    breadcrumbItemText3: 'grande',
    breadcrumbItemText4: 'bênção',
    breadcrumbItemText5: 'lucro',
    magnanimitydrawText: 'cupons maciços para você pegar',
    availablecouponstitleText: 'produtos selos disponíveis',
    drawbtnText: 'receber',
    universalText: ' universal para todo o campo',
    useText: 'uso',
    limitText: 'limited',
    fullText: 'cheio',
    subtractText: 'subtraindo',
    // 折扣
    discountitemText1: 'o desconto continua, ,',
    discountitemText2: 'juhui lianlian',
    // 组合
    commoditydiscountitemText1: 'combinação de compra ,',
    commoditydiscountitemText2: 'toto preferenciais',
    combinedpriceText: 'preço combinado',
    economizeText: 'salvar',
    buynowText: "comprar agora",
    // 产品
    ourproductsText: 'nossos produtos',
    productcategoryText: 'categorias de produtos',
    recommendtarText: 'recomendação',
    newText: 'novo chegado',
    salesvolumetarText: 'volume de venda',
    pricetarText: 'preço',
    // 博客
    blogmanagementText: "blogs populares",
    latestblogsText: "últimas notícias do blog",
    relatedrlogsText: "blogs relacionados",
    priceIncreasecommentText: "apresentar as suas observações",
    commentsectionTtxt: "área de comentários",
    participatingcommentsText: "participação",
    // 论坛
    postingText: "postar um post",
    topicsText: "tópico",
    replyText: "responder",
    viewText: "ver",
    lastreplyText: "última resposta",
    publishText: "publicar",
    placeholdertypeText: "por favor, selecione uma categoria de tópico",
    placeholdertitleText: "por favor, insira um título",
    placeholdercontentsText: "por favor, insira o conteúdo ",
    fromtopicText: "do tópic：",
    firstfloor: "1 º andar",
    floorText: "o edifício",
    fromText: "de:",
    postreplyText: "publicar uma resposta",
    // 个人中心 - 我的订单
    myorderText: "meus pedidos",
    mycommentsText: "meus comentários",
    mycollectionText: "minha coleção",
    couponText: "cupons",
    shippingaddressText: "endereço de entrega",
    myPostText: "meus posts",
    personalinformationText: "informações pessoais",
    editText: "editar",
    allordersText: "todos os pedidos",
    unpaidText: "a ser pago",
    shippedText: "a ser enviado",
    receivedText: "a ser recebido",
    evaluatedText: "a ser avaliado",
    baidText: "pagamento em substituição",
    completedText: "concluído",
    productinfText: "informações sobre o produto ",
    unitpricethText: "preço por unidade",
    quantitythText: "quantidade",
    actualpaymentthText: "pagamento real",
    transactionstatusthText: "status da transação ",
    operationthText: "operação",
    ordernumberText: "número do pedido",
    orderdetailsText: "detalhes do pedido",
    cancelorderText: "cancelar um pedido",
    confirmText: "ok",
    cancelText: "cancelar",
    deleteordertitle: "remover definitivamente a ordem atual?",
    successfultradeText: "sucesso comercial",
    paymentText: "pagamento",
    confirmreceiptText: "confirmação de recebimento",
    nncommentText: 'confirmação de recebimento',
    // 个人中心 - 我的评论
    productText: "produtos",
    productdetailText: "detalhes de avaliação",
    replyblogText: "responder ao blo：",
    //个人中心 - 收货地址
    addseliveryaddressText: "novo endereço de entrega",
    addaddresstitleText1: "salvo",
    addaddresstitleText2: "o endereço da barra, e pode salvar",
    addaddresstitleText3: "o endereço da barra",
    defaultText: "padrão",
    consigneeText: "destinatário",
    addressText: "endereço de localização:",
    fulladdressText: "endereço completo:",
    setdefaultText: "definir como padrão ",
    mobilephoneText: "telefone celular:",
    viewmoreText: "ver mais",
    replypostText: "responder ao post:",
    // 个人中心 - 个人信息
    nameLabel: "nome",
    sexlabel: "gênero",
    modifyavatarText: "alterar foto de perfil ",
    sexmanText: "masculino",
    sexwomanText: "mulher",
    secrecyText: "confidencialidade",
    replaceText: "substituir",
    saveText: "salvar",
    oldpasswordText: "a senha original ",
    newpasswordText: "nova senha",
    confirmpasswordText: "confirmar senha ",
    opdpleasolderText: "digite a senha original",
    newpleasolderText: "por favor, insira uma nova senha",
    unboundText: "não ligado",
    bindingText: "ligação",
    unbindingText: "desamarrar",
    // 个人中心-个人信息
    regionText: "região",
    addconsigneleasolderText: "preencher o nome do destinatário",
    countrypleasolderText: "por favor, selecione um país",
    provinceleasolderText: "por favor, selecione a província",
    citypleasolderText: "por favor, selecione a cidade",
    areapleasolderText: "por favor, selecione uma área",
    fulladdressTextpleasolderText: "digite o endereço completo",
    addconsignephoneleasolderText: "preencher número de telefone do destinatário",
    emailpleasolderText: "por favor, insira um endereço de e-mail",
    phoneText: 'número de celular',
    uploadimgText: "enviar imagem",
    updateuserface: "alterar avatar",
    uploadimgtitle1: "suporta imagens em JPG, jpeg, PNG ",
    uploadimgtitle2: "tamanho recomendado: 200*200 ou imagem igual escala",
    updateemailText: "alterar email",
    updatemobileText: "alterar número de telefone",
    dialogemailtitle: "endereço de e-mai",
    dialogmobiletitle: "número de telefone celular",
    dialogheadertitle: " a entrada está associada à sua conta jinger",
    continueText: "continue",
    verificationinformation: "informações de verificação",
    verificationinformationTitle1: "vai continuar a completar o processo de verificação, por favor. Nós temos sido capazes de",
    verificationinformationTitle2: "manda o captcha. Por favor, digite abaixo.",
    verificationcode: "código de verificação ",
    newtitle: "novo",
    dialognewmobiletitle: "digite o novo número de telefone a ser associado. E clique em confirmar a substituição",
    confirmpbtnText: "confirmar",
    titlecpuntryselect: "selecionar país",
    hotcountrytitle: "países populares",
    aboutusText: "sobre nós",
    // 订单详情
    havequestionsText: "tem dúvidas",
    preferentialText: "ofertas",
    enquiryText: "inquérito",
    combinationdiscountText: "oferta combinada",
    introduceText: "introdução",
    buyermycommentsText: "comentários do comprador ",
    starText: "estrela",
    yourmailboxText: "sua caixa de correio",
    placeholderquestionText: "por favor, escreva a sua pergunta",
    uploadimglimtText: "por favor, carregue um arquivo JPG/GIF/PNG. O tamanho da imagem não deve exceder 2MB.",
    submitbtnText: "submeter",
    // 购物车
    selectText: "seleção",
    tipscartsText: "produtos selecionados (sem custos de envio)",
    settlementText: "liquidação",
    selectallText: "selecionar tudo ",
    amountText: "quantidade",
    addtofavoritesText: "adicionar aos favoritos",
    havecollectedText: "coletado",
    tipdelecteproduct: "definitivamente remover o item atual?",
    deleteText: "remover",
    tipclearcart: "tem certeza de esvaziar o carrinho?",
    clearcartText: "esvaziar o carrinho ",
    totalText: "total",
    totaltipText: "item (sem frete):",


    // pieceText:"件",
    // freightText:"运费：",
    // taxationText:"税费：",
    // fullreductionamountText:"满减金额：",
    // amountpayableText:"应付金额：",
    // confirmorderText:"确认订单",
    // paymentsucceededText:"支付成功",
    // receivinginformationText:"收货信息",
    // othershippingaddressText:"其它收货地址",
    // addshippingaddressText:"添加收货地址",
    // selectshippingaddressText:"选择收货地址",
    // selfprimingText:"自提点",
    // typeofshippingText:"运输方式",
    // inquirecostsText:"点击此处咨询运费",
    // confirmproductinformationText:"确认产品信息",
    // settlementinformationText:"结算信息",
    // clipcoupons:"使用优惠券",
    // allitemsText:"全部商品",
    // validtoText:"有效期至",
    // pieceproductTotal:"件产品 总计：",
    // placeorder:"提交订单",
    // consultText:"咨询",
    // consultationText:"请输入咨询内容",
    // sendoutText:"发 送",
    // enterproductname:"输入产品名称",
    // contentText:"内容",
    // filerestrictionsText:"请上传JPG/GIF/PNG文件。图片大小不能超过2MB。",
    // withaccountText:"输入与您的 锦格 账户相关联的电子邮箱地址",
    // pagelostText:"很抱歉，你所访问的页面已失联",
    // pagelostText1:"秒后自动跳转到上一页，如没跳转 请点击刷新按钮",
    // pagelostText2:"刷新",
    // pagelostText3:"返回首页",
    // verificationrequiredText:"需要验证",
    // continuestepemailText:"要继续，请完成此验证步骤。 我们已向 电子邮件",
    // sendcodeText:"发送了验证码。 请在下面输入。",
    // resendverificationcodeText:"重新发送验证码",
    // createnewpasswordText:"创建新密码",
    // providepasswordText:"您在每次登录时，都需要提供此密码。",
    // savechangeText:"保存更改并登录",
    // shareToText1: 'follow us  on',
    // productDetailsText:"产品细节",
    // signedforText:"已签收",
    // rejectionText:"拒收",
    // evaluated1Text:"已评价",
    // reviewedText:"待审核",
    // PaidText:"已付款",
    // subtotalText:"小计",
    // waitingforpaymentText:"等待付款",
    // automaticclosingText:"来付款，超时订单自动关闭",
    // patientText:"尊敬的客户，您的订单正在出库，请您耐心等待。",
    // consigneeinformationText:"收货人信息",
    // paymentinformationText:"付款信息",
    // paymentmethodText:"付款方式：",
    // paymenttimeText:"付款时间：",
    // fullnameText:"全名",
  }
}




// WEBPACK FOOTER //
// ./src/assets/language/local_pt.js